import { createSlice } from '@reduxjs/toolkit';

export const subdomainSlice = createSlice({
  name: 'subdomain',
  initialState: 'www',
  reducers: {},
});

export const { reducer: subdomainReducer } = subdomainSlice;
